// extracted by mini-css-extract-plugin
module.exports = {"navigationMenu":"footer-navigation-menu-module--navigationMenu--1ptiD"};